"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

type CapWindow = Window & { Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string; Plugins?: { ItzPay?: unknown } } };

/**
 * Tells the server we are inside the phone app (see lib/shell.ts): lf_shell=ios|android, and
 * lf_pay=apple|google when this build carries the store's payment plugin. If either changed on this
 * load, refresh once so the server render already knows. In a browser it does nothing.
 */
export function ShellCookie() {
  const router = useRouter();
  useEffect(() => {
    const cap = (window as CapWindow).Capacitor;
    if (!cap?.isNativePlatform?.()) return;
    const p = cap.getPlatform?.() === "android" ? "android" : "ios";
    // An app does not pinch-zoom, and iOS must not auto-zoom into a field and leave the page shifted.
    // Our own tag, kept last (WebKit applies the last viewport meta; Next re-inserts its own).
    const m = document.createElement("meta");
    m.name = "viewport"; m.content = "width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover";
    document.head.appendChild(m);
    new MutationObserver(() => { if (document.head.lastElementChild !== m) document.head.appendChild(m); }).observe(document.head, { childList: true });
    const jar = document.cookie.split("; ");
    const set = (k: string, v: string) => { document.cookie = v ? `${k}=${v}; path=/; max-age=31536000; samesite=lax; secure` : `${k}=; path=/; max-age=0; samesite=lax; secure`; };
    const rail = cap.Plugins?.ItzPay ? (p === "android" ? "google" : "apple") : "";
    const shellOk = jar.includes(`lf_shell=${p}`);
    const payOk = rail ? jar.includes(`lf_pay=${rail}`) : !jar.some((c) => c.startsWith("lf_pay="));
    set("lf_shell", p); set("lf_pay", rail);
    if (!shellOk || !payOk) router.refresh();
  }, [router]);
  return null;
}
